import React from "react";
import { ChatCommandRouterServer } from "./types";
import ChatComposer from "./ChatComposer";
import ChatHeader from "./ChatHeader";
import ChatThread from "./ChatThread";
import classes from "./Chat.module.css";

type Props = {
  isOpen: boolean;
  isExpanded: boolean;
  composerHistoryKey: number;
  surfaceId: string;
  showDevControls: boolean;
  showEnvironmentSelector: boolean;
  commandRouterServer: ChatCommandRouterServer;
  onCommandRouterServerChange: (server: ChatCommandRouterServer) => void;
  onToggleExpanded: () => void;
};

const ChatPanel = ({
  isOpen,
  isExpanded,
  composerHistoryKey,
  surfaceId,
  showDevControls,
  showEnvironmentSelector,
  commandRouterServer,
  onCommandRouterServerChange,
  onToggleExpanded,
}: Props) => {
  return (
    <aside
      className={`${classes.chatPanel} ${isOpen ? classes.chatPanelOpen : ""} ${
        isExpanded ? classes.chatPanelExpanded : ""
      }`}
      aria-hidden={!isOpen}
    >
      <ChatHeader
        surfaceId={surfaceId}
        isExpanded={isExpanded}
        onToggleExpanded={onToggleExpanded}
        showDevControls={showDevControls}
        showEnvironmentSelector={showEnvironmentSelector}
        commandRouterServer={commandRouterServer}
        onCommandRouterServerChange={onCommandRouterServerChange}
      />
      <ChatThread />
      <ChatComposer key={composerHistoryKey} />
    </aside>
  );
};

export default ChatPanel;
